import PdfPane from '../../../shared/components/pdf/PdfPane.jsx';

/*
  Detail-page wrapper around the shared PdfPane (kept for the invoice / credit note detail pages and the PDF
  preview button). The selected key is reported back so the process step knows which file becomes the system document.
*/
export const PdfCard = ({ keys, selectedS3Key, setSelectedS3Key, setIsDirty, resource, height = '1000px' }) => {
  if (!keys) return null;
  return (
    <PdfPane
      resource={resource}
      keys={keys}
      selectedKey={selectedS3Key}
      onSelectKey={(key) => {
        if (selectedS3Key && key !== selectedS3Key && setIsDirty) setIsDirty(true);
        setSelectedS3Key(key);
      }}
      height={height}
    />
  );
};
